import { useEffect, useState } from 'react'
import { Box, Heading, Text, Table, Thead, Tbody, Tr, Th, Td, Badge, Spinner } from '@chakra-ui/react'
import axios from 'axios'

export default function AdminBooks() {
  const [books, setBooks] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios.get('/api/admin/books').then(r => { setBooks(r.data.books); setTotal(r.data.total) }).finally(() => setLoading(false))
  }, [])

  return (
    <Box p={8}>
      <Heading size="lg" fontFamily="Georgia, serif" color="brand.darkBlue" mb={2}>Books</Heading>
      <Text fontSize="14px" color="gray.500" mb={6}>{total} books written</Text>
      {loading ? <Spinner color="brand.orange" /> : (
        <Box bg="white" borderRadius="12px" border="1px solid #E2E2E2" overflow="hidden">
          <Table variant="simple" size="sm">
            <Thead bg="#F7F7F5">
              <Tr>
                <Th fontSize="11px" color="gray.500">Title</Th>
                <Th fontSize="11px" color="gray.500">Author</Th>
                <Th fontSize="11px" color="gray.500">Genre</Th>
                <Th fontSize="11px" color="gray.500">Words</Th>
                <Th fontSize="11px" color="gray.500">Status</Th>
                <Th fontSize="11px" color="gray.500">Date</Th>
              </Tr>
            </Thead>
            <Tbody>
              {books.map(b => (
                <Tr key={b.id} _hover={{ bg: '#F7F7F5' }}>
                  <Td fontSize="13px" fontWeight="500" color="brand.darkBlue" maxW="200px"><Text noOfLines={1}>{b.title}</Text></Td>
                  <Td fontSize="12px" color="gray.600">{b.author}</Td>
                  <Td fontSize="12px" color="gray.600">{b.genre || '—'}</Td>
                  <Td fontSize="12px" color="gray.600">{b.word_count?.toLocaleString()}</Td>
                  <Td><Badge fontSize="10px" px={2} bg={b.status === 'complete' ? '#1A6B2A15' : '#E8730015'} color={b.status === 'complete' ? '#1A6B2A' : '#E87300'} borderRadius="4px">{b.status}</Badge></Td>
                  <Td fontSize="12px" color="gray.400">{new Date(b.created_at).toLocaleDateString()}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  )
}
